import React from "react";
import Checkbox from "nq-component/dist/Checkbox";
import toDisplayCase from "nq-component/dist/toDisplayCase";
import { insertAfterKey } from "../common/Converter";

function Head({
  empPointer,
  indexCount,
  selectable,
  fields,
  excludeFields,
  isExcludeFieldOrder,
  excludeOrderFields,
  dynamicObject,
  specialColumn,
  actionsList,
  selected,
  onSelectAll,
  objects,
  fieldPointer = [],
}) {
  
  if(Array.isArray(fieldPointer) && fieldPointer.length > 0) {
    fields = insertAfterKey(fields, "employee", "fieldPointer", fieldPointer[0]);
  }

  const fieldKeys = isExcludeFieldOrder
    ? excludeOrderFields
    : Object.keys(fields);

  const singleHeader = {
    beforeNetAmount: [],
    fromNetAmount: [],
  };
  const contributionsHeader = [];
  const deductionsHeader = [];

  if (isExcludeFieldOrder) {
    fieldKeys.forEach((fieldKey) => {
      const fieldData = fields[fieldKey];

      if (!fieldData || excludeFields.includes(fieldKey)) return;

      const label = fieldData.label || toDisplayCase(fieldKey);

      if ((dynamicObject?.contributions ?? []).includes(label)) {
        contributionsHeader.push({ key: fieldKey, label });
      } else if ((dynamicObject?.deductions ?? []).includes(label)) {
        deductionsHeader.push({ key: fieldKey, label });
      } else if ((dynamicObject?.incentives ?? []).includes(label)) {
        deductionsHeader.push({ key: fieldKey, label });
      } else {
        if (fieldKey !== "netAmount") {
          singleHeader.beforeNetAmount.push({
            key: fieldKey,
            label,
            align: fieldData.align,
          });
        } else {
          singleHeader.fromNetAmount.push({
            key: fieldKey,
            label,
            align: fieldData.align,
          });
        }
      }
    });
  }

  const renderSingleHeader = (header) =>
    header.map((field) => (
      <th
        key={`item-${field.key}`}
        rowSpan={2}
        className={`align-middle text-nowrap text-dark ${
          field.align === "start" ? "text-start" : "text-center"
        }`}
        style={{
          padding: ".5rem 1rem",
          fontSize: "15px",
          backgroundColor: "rgba(0, 0, 0, .03)",
        }}
      >
        {field.label}
      </th>
    ));

  const _renderGroupHeader = (header, label) => {
    if (header.length === 0) return null;

    return (
      <th
        colSpan={header.length}
        className="text-center text-uppercase"
        style={{
          backgroundColor: "#f1f1f1",
          fontSize: "16px",
          padding: ".5rem 1rem",
        }}
      >
        {label}
      </th>
    );
  };

  const _renderSubHeaders = (header, bgColor) =>
    header.map((field) => (
      <th
        key={field.key}
        className="align-middle text-nowrap text-dark text-center"
        style={{
          padding: "1rem",
          fontSize: "15px",
          borderColor: "#d3d3d3",
          backgroundColor: bgColor,
        }}
      >
        {field.label}
      </th>
    ));

  return (
    <>
      {isExcludeFieldOrder && (
        <>
          <tr>
            {renderSingleHeader(singleHeader.beforeNetAmount)}

            {_renderGroupHeader(
              contributionsHeader,
              dynamicObject?.contributionsLabel
            )}
            {_renderGroupHeader(
              deductionsHeader,
              dynamicObject?.deductionsLabel
            )}
            {renderSingleHeader(singleHeader.fromNetAmount)}
          </tr>
          <tr>
            {_renderSubHeaders(contributionsHeader, "#cfecf3ff")}
            {_renderSubHeaders(deductionsHeader, "#d7f3d8ff")}
          </tr>
        </>
      )}
      <tr>
        {indexCount && (
          <th
            className="fs-xs align-middle text-nowrap text-dark"
            style={{
              //   padding: "1rem",
              paddingLeft: "1rem",
              fontSize: "15px",
              borderColor: "#d3d3d3",
              backgroundColor: "rgba(0, 0, 0, .03)",
            }}
            colSpan={actionsList.length}
          >
            No.
          </th>
        )}
        {selectable && (
          <th
            className="align-middle text-nowrap text-dark"
            style={{
              padding: "1rem",
              fontSize: "15px",
              borderColor: "#d3d3d3",
              backgroundColor: "rgba(0, 0, 0, .03)",
            }}
          >
            <Checkbox
              className="align-middle"
              id="check_all"
              checked={
                objects.length > 0 &&
                objects.every((obj) =>
                  selected.some((sel) => sel.id === obj.id)
                )
              }
              onChange={(checked) => onSelectAll(checked)}
            />
          </th>
        )}
        {!isExcludeFieldOrder &&
          fieldKeys.map((field, index) => {
            const fieldData = fields[field];

            if (!fieldData) {
              // console.warn(`Field "${field}" not found in schema.`);
              return null;
            }

            const { type, ...options } = fieldData;

            // console.log("options", options);
            if (excludeFields.includes(field)) return null;
            const label = options.label || toDisplayCase(field);
            const isPayrollRelation = label === "Payroll Relation";

            return (
              <th
                key={field}
                className="align-middle text-nowrap text-dark"
                style={{
                  padding: "1rem",
                  fontSize: "15px",
                  borderColor: "#d3d3d3",
                  backgroundColor: "rgba(0, 0, 0, .03)",
                  width: isPayrollRelation ? "275px" : undefined,
                  minWidth: isPayrollRelation ? "275px" : undefined,
                }}
              >
                {label}
              </th>
            );
          })}

        {specialColumn?.length > 0 && (
          <>
            <th
              className="align-middle text-nowrap text-dark"
              style={{
                padding: "1rem",
                fontSize: "15px",
                borderColor: "#d3d3d3",
                backgroundColor: "rgba(0, 0, 0, .03)",
              }}
            >
              Status
            </th>
          </>
        )}
        {actionsList?.length > 0 && (
          <>
            <th
              className="align-middle text-nowrap text-dark"
              style={{
                padding: "1rem",
                fontSize: "15px",
                borderColor: "#d3d3d3",
                backgroundColor: "rgba(0, 0, 0, .03)",
              }}
            >
              Actions
            </th>
          </>
        )}
      </tr>
    </>
  );
}

export default Head;
